import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteImageStyle($id: ID!) {
    deleteImageStyle(id: $id) {
      id
    }
  }
`;

export const deleteImageStyle = async (id) => {
  const variables = {
    id,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
